import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { LEGACY_DESTINATION } from '../services/authentication/legacy-access.service';

export const logoutGuard: CanActivateFn = (route) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const destino = route.queryParamMap.get('destino');
  const loginUrl = router.createUrlTree(['/login'], {
    queryParams: destino === LEGACY_DESTINATION ? { destino } : {},
  });

  const logout$ = authService.isLogged() ? authService.logout() : of(null);
  return logout$.pipe(map(() => loginUrl));
};
